export default __webpack_public_path__ + "static/media/space purple.60bc126a.png";